var map = {
	"./first-post.md": 1650,
	"./math-test.md": 2644,
	"./second-post.md": 7456,
	"./syntax-test.md": 2471,
	"content/blogs/first-post.md": 1650,
	"content/blogs/math-test.md": 2644,
	"content/blogs/second-post.md": 7456,
	"content/blogs/syntax-test.md": 2471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3605;